import { useParams } from "react-router-dom";
import DarCoins from "./DarCoins";
import DarTipeo from "./DarTipeo";
import LimiteTipeos from "./LimiteTipeos";
import EnviarPush from "./EnviarPush";


export default function PanelDinamico() {

    const { key } = useParams();


    const coins =
        localStorage.getItem("route_coins");

    const tipeos =
        localStorage.getItem("route_tipeos");

    const limiteTipeos =
        localStorage.getItem("route_limite_tipeos");

    const enviarPush =
        localStorage.getItem("route_enviar_push");



    if (key === coins) {
        return <DarCoins />;
    }


    if (key === tipeos) {
        return <DarTipeo />;
    }

    if (key === limiteTipeos) {
        return <LimiteTipeos />;
    }

    if (key === enviarPush) {
        return <EnviarPush />;
    }


    return (
        <h2>
            Página no encontrada
        </h2>
    );
}